export enum DataType {
  'String' = 0,
  'Number' = 1,
  'Boolean' = 2,
  'Date' = 3,
  'Link' = 4,
  'Template' = 5,
}
